import { render, staticRenderFns } from "./AccountingGroups.vue?vue&type=template&id=09c60c23&"
import script from "./AccountingGroups.vue?vue&type=script&lang=js&"
export * from "./AccountingGroups.vue?vue&type=script&lang=js&"
import style0 from "./AccountingGroups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports